import { GROUP } from "library/constants.mjs"
import { uniqueId } from "library/database/split-id.mjs"
import { PlanRoot } from "library/tree/constants.mjs"
import { TreeRoot } from "library/tree/index.mjs"

const STATE_LABELS = { draft: "Draft", live: "Live", ready: "Candidate", publish: "Review" }

/**
 * Return only an owner-verified total for the explicitly selected persisted regime state.
 * `state` (e.g. "live") picks that version of a draft regime item instead of the item's own version.
 */
export function getSelectedRegimeScheduleTotal({ item, selectedId, currentClient, enabled, sharing, state }) {
    if (!enabled || sharing || typeof currentClient !== "string" || !currentClient) return undefined
    if (!item || item.type !== GROUP || !item[PlanRoot] || item[TreeRoot]) return undefined
    if (selectedId !== item.id || item._id !== item.id) return undefined

    const selected = parseStateIdentity(state ? `${state}|${item.id}` : item.id)
    const definition = parseStateIdentity(item.$?._id, true)
    const summary = item.$?.scheduleTotals
    if (!selected || !definition || selected.base !== definition.base) return undefined
    if (summary?.owner !== currentClient || !Array.isArray(summary.states)) return undefined

    const matches = summary.states.filter(matchesSelectedState)
    if (matches.length !== 1) return undefined
    const { count } = matches[0]
    if (!Number.isInteger(count) || count < 0 || count > 2147483647) return undefined
    return { count, label: STATE_LABELS[selected.state] }

    function matchesSelectedState(entry) {
        const identity = parseStateIdentity(entry?.treeId, true)
        return identity?.id === selected.id
    }
}

function parseStateIdentity(value, persisted = false) {
    if (typeof value !== "string") return undefined
    if (persisted && !value.endsWith(":sfg20/tree")) return undefined
    const id = uniqueId(value)
    if (persisted && `${id}:sfg20/tree` !== value) return undefined
    if (!persisted && id !== value) return undefined
    const parts = id.split("|")
    const state = parts.length === 1 ? "draft" : parts[0]
    const base = parts.at(-1)
    if (parts.length > 2 || (parts.length === 2 && state === "draft")) return undefined
    if (!Object.hasOwn(STATE_LABELS, state) || !/^[A-Za-z0-9_-]+$/.test(base)) return undefined
    return { id, base, state }
}
